/* Katha Bundle Studio — layered photo preview (front view).
   All FRONT renders share one camera, so a piece can be cut out of one colour's render
   and laid over another's. Coordinates are % of the full render (921 x 1152 at 4:5). */
(function(){
  const P = {
    pillowL: [[31.8,34.3],[33.5,34.0],[36,33.9],[39.3,33.8],[43,33.7],[46,33.6],[47.6,33.5],[47.9,33.9],[48.0,35.6],[48.1,38.0],[48.4,39.7],[48.7,40.4],[32.5,40.4],[32.4,39.7],[32.1,37.5],[31.9,35.5]],
    pillowR: [[51.0,33.85],[51.4,34.0],[53,34.3],[55.1,34.4],[58,34.4],[61.1,34.3],[64,34.0],[66.3,33.6],[67.1,33.4],[67.2,34.0],[67.1,35.6],[67.0,38.0],[66.9,39.9],[66.8,40.4],[51.3,40.6],[51.0,39.8],[50.7,39.25],[49.9,38.6],[49.8,38.4],[50.6,38.0],[51.6,37.4],[51.6,36.8],[51.3,35.0]],
    band: [[27.6,42.25],[28.3,41.7],[29.4,41.0],[30.6,40.35],[32.0,39.75],[40,39.8],[48,39.85],[51,39.85],[60,39.9],[66.8,39.95],[68.2,40.4],[69.6,41.0],[71.0,41.7],[72.0,42.25],[66,42.1],[58,42.05],[50,42.0],[42,42.05],[34,42.1]],
    bed: [[32.2,39.4],[48.6,39.5],[51.2,39.5],[66.8,39.4],[68.1,39.9],[71.2,40.9],[73.0,42.2],[76.1,44.4],[79.8,46.8],[82.5,49.3],[84.1,51.7],[85.3,55.2],[85.9,57.6],[87.9,60.1],[87.8,60.4],[84.7,60.7],[69.3,61.0],[50.9,61.1],[32.5,61.0],[20.3,61.1],[12.7,60.9],[12.6,60.3],[14.7,58.6],[16.6,56.6],[18.1,54.2],[20.3,51.7],[22.1,48.8],[24.3,45.4],[26.4,42.4],[28.2,41.2],[30.3,40.3],[32.2,39.6]]
  };
  const SVGNS = 'http://www.w3.org/2000/svg';
  /* dilate grows the cut-out slightly so the piece underneath never shows as a rim */
  function maskURL(polys, blur, dilate){
    const shapes = polys.map(pts => `<polygon points='${pts.map(p=>(p[0]*10).toFixed(1)+','+(p[1]*10).toFixed(1)).join(' ')}' fill='white'/>`).join('');
    const svg = `<svg xmlns='${SVGNS}' viewBox='0 0 1000 1000' preserveAspectRatio='none'><filter id='b' filterUnits='userSpaceOnUse' x='0' y='0' width='1000' height='1000'>${dilate ? `<feMorphology operator='dilate' radius='${dilate}'/>` : ''}<feGaussianBlur stdDeviation='${blur}'/></filter><g filter='url(#b)'>${shapes}</g></svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
  }
  const MASK = {
    pillows: maskURL([P.pillowL, P.pillowR], 1.2, 1.5),
    band: maskURL([P.band], 0.9, 1.5),
    bed: maskURL([P.bed, P.pillowL, P.pillowR], 1.2, 2)
  };
  function el(tag, cls, css){ const e = document.createElement(tag); if (cls) e.className = cls; if (css) e.style.cssText = css; return e; }
  function setMask(e, m){ if (!m) return; e.style.webkitMaskImage = m; e.style.maskImage = m; e.style.webkitMaskSize = '100% 100%'; e.style.maskSize = '100% 100%'; e.style.webkitMaskRepeat = 'no-repeat'; e.style.maskRepeat = 'no-repeat'; }

  /* src: {img:url} for a real render, or {tint:'#hex', base:url} to colour the white render */
  function paint(src, maskKey){
    const g = el('div', 'kbp-l', 'position:absolute;inset:0;opacity:0;transition:opacity .35s ease;isolation:isolate');
    if (src.img){
      const i = el('img', '', 'position:absolute;inset:0;width:100%;height:100%;display:block;max-width:none'); i.alt = ''; i.decoding = 'async'; i.src = src.img; g.appendChild(i);
      g._ready = i.decode ? i.decode().catch(()=>{}) : Promise.resolve();
    } else {
      /* no render for this colour yet: colour the white render (bed area only, background untouched) */
      const i = el('img', '', 'position:absolute;inset:0;width:100%;height:100%;display:block;max-width:none'); i.alt=''; i.src = src.base; g.appendChild(i);
      const c = el('div', '', 'position:absolute;inset:0;isolation:isolate'); setMask(c, MASK.bed);
      const i2 = el('img', '', 'position:absolute;inset:0;width:100%;height:100%;display:block;max-width:none;filter:saturate(0) brightness(1.09) contrast(1.05)'); i2.alt=''; i2.src = src.base; c.appendChild(i2);
      c.appendChild(el('div', '', `position:absolute;inset:0;background:${src.tint};mix-blend-mode:multiply`));
      g.appendChild(c);
      g._ready = i.decode ? i.decode().catch(()=>{}) : Promise.resolve();
    }
    setMask(g, maskKey ? MASK[maskKey] : null);
    return g;
  }
  function Slot(parent, maskKey, wrapCss){
    const w = el('div', 'kbp-slot', 'position:absolute;inset:0;' + (wrapCss||'')); parent.appendChild(w);
    let cur = null, key = '';
    return {
      wrap: w,
      set(src){
        const k = src ? (src.img || (src.base + src.tint)) : '';
        if (k === key) return; key = k;
        if (!src){ if (cur){ const old = cur; old.style.opacity = 0; setTimeout(()=>old.remove(), 400); cur = null; } return; }
        const g = paint(src, maskKey); w.appendChild(g);
        cur = g;
        g._ready.then(()=>{ if (!g.isConnected) return; requestAnimationFrame(()=>{ g.style.opacity = 1; setTimeout(()=>{ let p = g.previousElementSibling; while (p){ const q = p.previousElementSibling; p.remove(); p = q; } }, 400); }); });
      }
    };
  }
  /* mount(viewportEl) -> {set({duvet,flat,back,front})} each value a src object or null */
  window.KathaBedPhoto = function mount(vp){
    /* phones: a slightly taller frame so the note under the bed never covers the duvet */
    if (!document.getElementById('kbpCss')){ const st = el('style'); st.id = 'kbpCss'; st.textContent = '@media (max-width:600px){#kbsRoot .kbs-viewport{aspect-ratio:1.18 !important}#kbsRoot .kbs-hint{bottom:8px;padding:0 12px}}'; document.head.appendChild(st); }
    const stage = el('div', 'kbp-stage', 'position:absolute;left:-9.5%;width:119%;aspect-ratio:921/1152;top:50%;transform:translateY(-47.4%)');
    vp.appendChild(stage);
    const sDuvet = Slot(stage, null);
    const sFlat = Slot(stage, 'band');
    const sBack = Slot(stage, 'pillows', 'transform:translateY(-2.1%) scale(.972);transform-origin:49.5% 37%');
    const sFront = Slot(stage, 'pillows', 'filter:drop-shadow(0 -1px 2px rgba(20,20,20,.18))');
    return { stage, set(o){ sDuvet.set(o.duvet); sFlat.set(o.flat); sBack.set(o.back); sFront.set(o.front); } };
  };
  /* the piece outlines, for tapping a piece on the photo (homepage live bed) */
  window.KathaBedPhoto.P = P;
  window.KathaBedPhoto.MASK = MASK;
})();
